// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ar-style .rules-icon {\n  transform: rotateY(0deg) !important;\n}\n.ar-style .policy-flag {\n  margin-right: 0.42667rem;\n  margin-left: 0 !important;\n  border-radius: 0 0.32rem 0.32rem 0 !important;\n}", ""]);
// Exports
module.exports = exports;
